import React, { useMemo, ReactNode, createContext, useContext } from "react";

import { EndpointAddonRaw } from "@/domain/EndpointAddon";
import { useEndpointAddonsAPI } from "../hooks";

const endpointAddonCtx = createContext<{
  endpointAddons: EndpointAddonRaw[] | null;
  runReloadEndpointAddons: () => Promise<void>;
  isLoadedEndpointAddons: boolean;
}>({
  endpointAddons: null,
  runReloadEndpointAddons: async () => {},
  isLoadedEndpointAddons: false,
});

export const EndpointAddonsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const {
    state: endpointAddons,
    runReloadState: runReloadEndpointAddons,
    isLoadedState: isLoadedEndpointAddons,
  } = useEndpointAddonsAPI();

  const endpointAddonCtxValue = useMemo(
    () => ({
      endpointAddons,
      runReloadEndpointAddons,
      isLoadedEndpointAddons,
    }),
    [endpointAddons, runReloadEndpointAddons, isLoadedEndpointAddons]
  );

  return (
    <endpointAddonCtx.Provider value={endpointAddonCtxValue}>
      {children}
    </endpointAddonCtx.Provider>
  );
};

export const useEndpointAddons = () => {
  return useContext(endpointAddonCtx);
};
